import React, { useState, ReactNode } from 'react'
import { ReactNodeArray } from 'prop-types'
import { StyledSwitcher, StyledButton, StyledSwitchContent } from './styled'

export interface ISwitch {
  label: string
  disabled?: boolean
  onClick?: () => void
}

interface ISwitchTemplate {
  buttons: ISwitch[]
  children: ReactNodeArray
}
interface ISwitchContent {
  hidden: boolean
  children: ReactNode
}

export const SwitchContent = ({ children, hidden }: ISwitchContent) => (
  <StyledSwitchContent hidden={hidden}>{children}</StyledSwitchContent>
)

export const SwitchTemplate = ({ buttons, children }: ISwitchTemplate) => {
  const [activeButton, setActiveButton] = useState(0)
  return (
    <>
      <StyledSwitcher>
        {buttons.map(({ label, disabled, onClick }, index) => (
          <StyledButton
            key={index}
            color="primary"
            variant={activeButton === index ? 'contained' : 'text'}
            onClick={() => {
              setActiveButton(index)
              if (onClick) {
                onClick()
              }
            }}
            disabled={disabled}
          >
            {label}
          </StyledButton>
        ))}
      </StyledSwitcher>
      {children.map((content, index) => (
        <SwitchContent key={index} hidden={activeButton !== index}>
          {content}
        </SwitchContent>
      ))}
    </>
  )
}
